import React from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Checkbox,
  Typography,
} from "@mui/material";
import * as premiumApi from "../../api/premiumApi";
import { Link } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ScrollToTopBtn from "../common/ScrollToTop";
import { connect } from "react-redux";

class VintageListUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vintages: [],
      page: 0,
      rowsPerPage: 50,
      membership: props.type,
    };
  }

  async componentDidMount() {
    try {
      this.fetchVintages();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      const membership = this.props.type;
      this.setState(
        {
          vintages: [],
          page: 0,
          rowsPerPage: 50,
          membership,
        },
        () => {
          this.fetchVintages();
        }
      );
    }
  }

  async fetchVintages() {
    try {
      const vintages = await premiumApi.getVintages(this.state.membership);
      if (vintages) {
        vintages.sort((a, b) => (a.vintageYear < b.vintageYear ? 1 : -1));
        this.setState({ vintages });
      } else {
        this.setState({ vintages: [] });
      }
    } catch (error) {
      console.log("Error in fetchVintages", error);
    }
  }

  handleChangePage = (_event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  render() {
    const layout = {
      width: "80%",
      paddingTop: 80,
      margin: "auto",
    };

    const tableWrapper = {
      marginTop: 10,
      overflow: "auto",
    };

    const headStyle = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
    };

    const linkStyle = {
      textDecoration: "none",
      color: "#673ab7",
    };

    const emptyPaperStyle = {
      paddingTop: 45,
      paddingLeft: 50,
    };

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={layout}>
            <div style={{ marginLeft: 10 }}>
              <h2>Årganger {this.state.membership}</h2>
            </div>
            <Paper>
              <div style={tableWrapper}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={headStyle}></TableCell>
                      <TableCell style={headStyle}>År</TableCell>
                      <TableCell style={headStyle}>Avsluttet</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.vintages.length > 0 ? (
                      this.state.vintages
                        .slice(
                          this.state.page * this.state.rowsPerPage,
                          this.state.page * this.state.rowsPerPage +
                          this.state.rowsPerPage
                        )
                        .map((vintage, index) => (
                          <TableRow key={index} hover>
                            <TableCell align="center">
                              <Link
                                to={`/policyyear${this.state.membership.toLowerCase()}/${vintage.vintageYear}`}
                                style={linkStyle}
                              >
                                <Button
                                  variant="outlined"
                                  size="medium"
                                  color="primary"
                                  style={{ margin: 8 }}
                                >
                                  <ArrowForwardIosIcon
                                    style={{ marginRight: 8 }}
                                  />
                                  Vis Mer
                                </Button>
                              </Link>
                            </TableCell>
                            <TableCell>{vintage.vintageYear}</TableCell>
                            <TableCell>
                              <Checkbox
                                checked={!!vintage.ended}
                                color="default"
                              />
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          <Typography style={emptyPaperStyle}>Ingen treff</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                rowsPerPageOptions={[10, 50, 100]}
                component="div"
                count={this.state.vintages.length}
                rowsPerPage={this.state.rowsPerPage}
                page={this.state.page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const signedinuser = state.signedinuserobject
    ? state.signedinuserobject.signedInUser
    : sessionStorage.getItem("token")
      ? JSON.parse(sessionStorage.getItem("token"))
      : [];

  return { signedinuser: signedinuser };
}

export default connect(mapStateToProps)(VintageListUser);
